export enum TransferScheme {
    SEPA = 'SEPA',
    SWIFT = 'SWIFT'
}

export enum ProcessingModule {
    SEPA_MMS_CT = 'SEPA_MMS_CT',
    SEPA_MMS_CT_INST = 'SEPA_MMS_CT_INST',
    CURRENCY_CLOUD = 'CURRENCY_CLOUD'
}

export enum OrderType {
    CANCEL = 'CANCEL',
    RETURN = 'RETURN',
    OUTGOING = 'OUTGOING',
    INCOMING = 'INCOMING',
}

export enum OrderState {
    NEW = 'NEW',
    // The backend sends IN_PROGRESS (PaymentProcessingOrderState); PROGRESS is kept for existing code
    PROGRESS = 'PROGRESS',
    IN_PROGRESS = 'IN_PROGRESS',
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED',
    ERROR = 'ERROR',
    SUSPENDED = 'SUSPENDED',

    ACCEPTED_DELIVERED = 'ACCEPTED_DELIVERED',
    ACCEPTED_UNDELIVERED = 'ACCEPTED_UNDELIVERED'
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/constants/processing.order.ts